import { useEffect, useRef } from "react";

export interface UseMissingSectionFocusOptions {
  /** Save & Sign press count from the form status; each new value focuses the first empty section. */
  attempt: number;
  firstMissingKey?: string;
  goToSection: (key: string) => void;
}

/** After every Save & Sign press, opens and scrolls to the first section still missing. */
export const useMissingSectionFocus = ({
  attempt,
  firstMissingKey,
  goToSection,
}: UseMissingSectionFocusOptions): void => {
  const handledAttempt = useRef(attempt);
  useEffect(() => {
    if (attempt === handledAttempt.current) return;
    handledAttempt.current = attempt;
    if (firstMissingKey) goToSection(firstMissingKey);
  }, [attempt, firstMissingKey, goToSection]);
};
